import React, { Component } from 'react'
import MediaQuery from 'components/MediaQuery/MediaQuery'
import Button from 'components/UI/Button/Button'
import Icon from 'components/UI/Icon/Icon'
import ModalContext from 'components/Context/ModalContext'
import UpgradePopup from '../../../../../DashboardPopup/UpgradePopup/UpgradePopup'
import TeacherInfoRow from '../TeacherInfoRow/TeacherInfoRow'

import {
  Wrapper,
  BottomButtonRow,
  AddButtonText,
  HelperText
} from './TeachersColumn.styles'
import { Title } from '../../../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class TeachersColumn extends Component {
  getNumberOfTeachers () {
    return this.props.teachers.filter(teacher => (
      !teacher.isNew && !teacher.stagedForDeletion
    )).length
  }

  renderTeachers () {
    return (
      <MediaQuery>
        {this.props.teachers.map((teacher, i) => {
          return (
            <TeacherInfoRow
              key={teacher._id}
              info={teacher}
              isFirstRow={i === 0}
              isEditMode={this.props.isEditMode}
              isLoggedInUser={this.props.loggedInUser === teacher._id}
              numberOfTeachers={this.getNumberOfTeachers()}
              onRemoveTeacher={this.props.onRemoveTeacher}
              setTeacherState={this.props.setTeacherState}
            />
          )
        })
        }
      </MediaQuery>
    )
  }

  renderBottomButtonRow (modal) {
    return (
      <BottomButtonRow>
        <Button
          element='button'
          bgColor={colors.orange}
          color='white'
          size='regular'
          round
          onClick={() => this.canAddMoreTeachers()
            ? this.props.onAddTeacher()
            : modal.open(<UpgradePopup subscriptionStatus={this.props.subscriptionStatus} />)
          }
        >
          <Icon
            name='plus'
            color='white'
            size='regular'
          />
        </Button>
        <AddButtonText
          onClick={() => (this.canAddMoreTeachers()
            ? this.props.onAddTeacher()
            : modal.open(<UpgradePopup subscriptionStatus={this.props.subscriptionStatus} />)
          )}
        >
					Add Teacher
        </AddButtonText>
        <HelperText>
          {this.getAvailableTeachersText()}
        </HelperText>
      </BottomButtonRow>
    )
  }

  canAddMoreTeachers () {
    const { subscriptionStatus } = this.props
    if (subscriptionStatus !== 'custom') return false

    if (this.props.allowedTeachers === 5) return true
    const availTeachers = this.props.allowedTeachers && this.props.allowedTeachers - this.props.teachers.length
    return availTeachers > 0
  }

  getAvailableTeachersText () {
    if (this.props.subscriptionStatus === 'trial') {
      return 'Please upgrade to add more teachers to your school'
    }
    if (this.props.subscriptionStatus === 'stripe') {
      return 'Please upgrade to a custom plan to add more teachers to your school'
    }
    if (this.props.subscriptionStatus === 'expired') {
      return 'Please renew your subscription to add more teachers to your school'
    }

    // If allowedTeachers is 5, can add as many as they like
    if (this.props.allowedTeachers === 5) return 'All teachers need an existing Night Zookeeper account'

    const availTeachers = this.props.allowedTeachers && this.props.allowedTeachers - this.props.teachers.length
    if (availTeachers > 0) {
      return `You can add ${availTeachers} more teacher${availTeachers > 1 ? 's' : ''} on your current plan.
      All teachers need an existing Night Zookeeper account`
    }
    return 'You have reached the maximum number of teachers for your plan'
  }

  render () {
    return (
      <Wrapper>
        <Title>
					Teachers
        </Title>
        {this.renderTeachers()}
        <ModalContext.Consumer>
          {modal => this.renderBottomButtonRow(modal)}
        </ModalContext.Consumer>
      </Wrapper>
    )
  }
}
